export const year_diff = 1; //เดิมคือ 1
export const year_diff_temp = 1;
export const session_year = "coop_agri_year";
export const session_sector = "coop_sector";
export const masterSector = [
    {
        name: "ทั้งหมด",
        value: "0"
    },
    {
        name: "ภาคการเกษตร",
        value: "1"
    },
    {
        name: "นอกภาคการเกษตร",
        value: "2"
    }
];

export class callable {
    public static shiftYear(data, years, keyYear = "year") {

        let arr = [];

        for (let i = 0; i < data.length; i++) {
            for (let j = 0; j < years.length; j++) {
                if (data[i][keyYear] == years[j]) {
                    arr.push(data[i])
                    break;
                }
            }
        }

        return arr
    }

    public static checkYearNow() {
        var max = (new Date().getFullYear() - year_diff) + 543
        const y = sessionStorage.getItem(session_year);
        if (y) {
            max = parseInt(y);
        }
        var min = max - 5;
        var years = [];

        for (var i = max; i >= min; i--) {
            years.push(i)
        }

        return years;
    }

    public static listYear() {
        var max = (new Date().getFullYear() - year_diff) + 543
        console.log('max',max);

        var min = 2558;
        var years = [];

        for (var i = max; i >= min; i--) {
            years.push(i)
        }

        return years;
    }

    public static getCurrentYear(year = null) {
        const y = sessionStorage.getItem(session_year);

        if (year) {
            sessionStorage.setItem(session_year, year);
            return year;
        }

        if (!year && y) {
            return y;
        }

        const y2 = (new Date().getFullYear() - year_diff) + 543;
        sessionStorage.setItem(session_year, y2.toString());
        return y2;
    }

    public static getCurrentYearTemp(year = null) {
        const y = sessionStorage.getItem(session_year);

        if (year) {
            sessionStorage.setItem(session_year, year);
            return year;
        }

        if (!year && y) {
            return y;
        }

        const y2 = (new Date().getFullYear() - year_diff_temp) + 543;
        sessionStorage.setItem(session_year, y2.toString());
        return y2;
    }

    public static setPathParam(param, yc = null, year = null) {
        let url = param + `?${yc ? `year_change` : `year`}=`;
        const y = sessionStorage.getItem(session_year);
        if (year) {
            url += year;
        } else if (!y) {
            url += (new Date().getFullYear() - year_diff) + 543
        } else {
            url += y;
        }
        return url;
    }

    public static setPathParamSector(path, isNonSector = false) {
        // isNonSector is null : All / สหกรณ์ภาคการเกษตร / สหกรณ์นอกภาคการเกษตร
        let url = path + `&sector=`;
        let s: any = sessionStorage.getItem(session_sector);
        if (!s) {
            s = "0";
            sessionStorage.setItem(session_sector, s);
        }
        if (isNonSector) {
            switch (s) {
                case "0":
                    s = "null";
                    break;
                case "1":
                    s = "สหกรณ์ภาคการเกษตร";
                    break;
                case "2":
                    s = "สหกรณ์นอกภาคการเกษตร";
                    break;
            }
        }
        url += s;
        return url
    }

    public static getMasterSector() {
        return masterSector;
    }

    public static getCurrentSector(sector = null) {
        let s = sessionStorage.getItem(session_sector);

        if (sector) {
            sessionStorage.setItem(session_sector, sector);
            return sector;
        }
        if (!sector && s) {
            return s;
        }

        s = "0";
        sessionStorage.setItem(session_sector, s);
        return s;
    }
}
